<template>
  <span>
    <v-btn
      text
      v-show="$vuetify.breakpoint.mdAndUp && compute(button.visible, true)"
      :disabled="compute(button.disabled, false)"
      :color="compute(button.color)"
      small
      v-bind="activator.attrs"
      v-on="activator.on"
      @click="compute(button.click)">
      <v-icon left>{{ compute(button.icon) }}</v-icon>
      {{ compute(button.text) }}
    </v-btn>
    <v-btn
      icon
      v-show="!$vuetify.breakpoint.mdAndUp && compute(button.visible, true)"
      :disabled="compute(button.disabled, false)"
      :color="compute(button.color)"
      v-bind="activator.attrs"
      v-on="activator.on"
      @click="compute(button.click)">
      <v-icon>{{ compute(button.icon) }}</v-icon>
    </v-btn>
  </span>
</template>

<script>
export default {
  name: 'AActionButtonBarItem',
  props: ['button', 'options', 'activator'],
  methods: {
    compute (value, defaultValue) {
      if (value === undefined) {
        return defaultValue
      } else if (value instanceof Function) {
        return value(this.options)
      } else {
        return value
      }
    }
  }
}
</script>

<style scoped>

</style>